export default {
  CREATE_DOCTOR(state, payload) {},
  GET_DOCTOR(state, payload) {
    state.doctor = payload;
  },
  EDIT_DOCTOR(state, payload) {},
  DELETE_DOCTOR(state, payload) {},
};
